import { TTS_STOP_REASONS, type TtsStopReason } from './analytics-constants';

/**
 * Module-level controller for stopping the active TTS session.
 * Mirrors the active-dictation pattern so TTS and dictation can
 * mutually exclude each other without React coupling.
 *
 * Also exposes a small "active context" block so the pagehide beacon
 * hook can build an accurate tts_ended payload without owning adapter state.
 */

type StopFn = (reason: TtsStopReason) => void;
let activeTtsStop: StopFn | null = null;

export function registerActiveTts(stopFn: StopFn): void {
  activeTtsStop = stopFn;
}

export function clearActiveTts(): void {
  activeTtsStop = null;
}

export function stopActiveTts(reason: TtsStopReason = TTS_STOP_REASONS.USER_STOPPED): void {
  activeTtsStop?.(reason);
  activeTtsStop = null;
}

export interface ActiveTtsContext {
  startTime: number;
  staticProperties: Record<string, unknown>;
  // Returns properties whose value changes over the lifetime of the utterance
  // (e.g. `wordsPlayed`). Read at beacon time so the snapshot reflects the
  // moment of the page navigation.
  getDynamicProperties: () => Record<string, unknown>;
}

let activeTtsContext: ActiveTtsContext | null = null;

export function setActiveTtsContext(ctx: ActiveTtsContext | null): void {
  activeTtsContext = ctx;
}

export function getActiveTtsContext(): ActiveTtsContext | null {
  return activeTtsContext;
}
